export default {
  namespaced: true,
  state: {
    countryCodes: [
      { title: 'AF', value: '+93' },
      { title: 'AL', value: '+355' },
      { title: 'AR', value: '+54' },
      { title: 'AM', value: '+374' },
      { title: 'AU', value: '+61' },
      { title: 'AT', value: '+43' },
      { title: 'AZ', value: '+994' },
      { title: 'BD', value: '+880' },
      { title: 'BY', value: '+375' },
      { title: 'BE', value: '+32' },
      { title: 'BM', value: '+1-441' },
      { title: 'BO', value: '+591' },
      { title: 'BR', value: '+55' },
      { title: 'BG', value: '+359' },
      { title: 'CM', value: '+237' },
      { title: 'CA', value: '+1' },
      { title: 'CL', value: '+56' },
      { title: 'CN', value: '+86' },
      { title: 'CR', value: '+506' },
      { title: 'HR', value: '+385' },
      { title: 'CU', value: '+53' },
      { title: 'CY', value: '+357' },
      { title: 'CZ', value: '+420' },
      { title: 'DK', value: '+45' },
      { title: 'EG', value: '+20' },
      { title: 'FR', value: '+33' },
      { title: 'DE', value: '+49' },
      { title: 'GR', value: '+30' },
      { title: 'HK', value: '+852' },
      { title: 'HU', value: '+36' },
      { title: 'IS', value: '+354' },
      { title: 'IN', value: '+91' },
      { title: 'ID', value: '+62' },
      { title: 'IR', value: '+98' },
      { title: 'IQ', value: '+964' },
      { title: 'IE', value: '+353' },
      { title: 'IL', value: '+972' },
      { title: 'IT', value: '+39' },
      { title: 'JM', value: '+1-876' },
      { title: 'JP', value: '+81' },
      { title: 'MX', value: '+52' },
      { title: 'MD', value: '+373' },
      { title: 'MC', value: '+377' },
      { title: 'MA', value: '+212' },
      { title: 'NP', value: '+977' },
      { title: 'NL', value: '+31' },
      { title: 'NG', value: '+234' },
      { title: 'KP', value: '+850' },
      { title: 'NO', value: '+47' },
      { title: 'PK', value: '+92' },
      { title: 'PS', value: '+970' },
      { title: 'PA', value: '+507' },
      { title: 'PY', value: '+595' },
      { title: 'PE', value: '+51' },
      { title: 'PL', value: '+48' },
      { title: 'PT', value: '+351' },
      { title: 'QA', value: '+974' },
      { title: 'RO', value: '+40' },
      { title: 'RU', value: '+7' },
      { title: 'SA', value: '+966' },
      { title: 'SN', value: '+221' },
      { title: 'RS', value: '+381' },
      { title: 'SG', value: '+65' },
      { title: 'SK', value: '+421' },
      { title: 'SI', value: '+386' },
      { title: 'ZA', value: '+27' },
      { title: 'KR', value: '+82' },
      { title: 'SS', value: '+211' },
      { title: 'ES', value: '+34' },
      { title: 'SD', value: '+249' },
      { title: 'SZ', value: '+268' },
      { title: 'SE', value: '+46' },
      { title: 'CH', value: '+41' },
      { title: 'SY', value: '+963' },
      { title: 'TH', value: '+66' },
      { title: 'TR', value: '+90' },
      { title: 'UA', value: '+380' },
      { title: 'AE', value: '+971' },
      { title: 'GB', value: '+44' },
      { title: 'US', value: '+1' },
      { title: 'UY', value: '+598' },
      { title: 'VA', value: '+379' },
      { title: 'VE', value: '+58' },
      { title: 'VN', value: '+84' }
    ]
  },
  getters: {
    getCountryCodes: state => state.countryCodes
  }
}
